import ApexCharts, {ApexOptions} from 'apexcharts'
import React, {useEffect, useRef} from 'react'
import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'

type Props = {
  className: string
}

const ChartBerandaPie: React.FC<Props> = ({className}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height))
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>Distribusi Realisasi Anggaran</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        <div
          ref={chartRef}
          id='kt_charts_distribusi_realisasi_anggaran'
          style={{height: '350px'}}
        ></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export default ChartBerandaPie
function getChartOptions(height: number): ApexOptions {
  const color1: string = '#846611'
  const color2: string = '#F26A66'
  const color3: string = '#D91CA8'

  return {
    series: [22, 45, 33],
    labels: ['Deputi Risbang', 'Deputi Inovasi', 'Pusat Data dan Informasi'],
    chart: {
      fontFamily: 'inherit',
      type: 'donut',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    title: {
        text: 'Realisasi Anggaran Rp. 899.191.785.869,-',
        align: 'center',
        style: {
            fontWeight: 600,
        }
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        customScale: 1,
      },
    },
    legend: {
      show: true,
      markers: {
        fillColors: [color1, color2, color3],
      },
      position: 'bottom',
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      colors: [color1, color2, color3],
    },
    colors: [color1, color2, color3],
    
  }
}
